<template>
  <div class="item">
    <div class="item-header">
      <div class="item-header-title">OWN PRODUCTS AEC</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>AEC自有产品</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">专业技术服务团队，为客户信息化平台保驾护航。</div>
    </div>

    <div class="item-content">
      <div class="tabs">
        <div :key="i" v-for="(item,i) in currentTabs" :class="tabClasses(i)" @click="tabClick(i)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="tabs-content">
        <div class="imgs" :style="getWrapStyle">
          <img
            :key="i" 
            v-for="(item,i) in currentTabs"
            :src="'http://tarzan.minus.live' + item.img"
            @click="toProduct(i)"
            @load="(node) => loadImage(node, i)"
            :height="imgHeight[i] ? imgHeight[i] : 0" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      tabActiveIndex: 0,
      currentTabs: this.tabs.filter(item => (item.desc === 'aecHome')),
      imgHeight: []
    }
  },

  props: {
    tabs: {
      type: Array,
      required: true
    }
  },

  methods: {
    showBoard () {
      window.eventBus.$emit('boardShow')
    },

    toProduct (i) {
      this.$router.push(`/introduction`)
      document.body.scrollIntoView()
      setTimeout(() => {
        window.location.hash = `#introduction${i + 1}`
      })
    },

    tabClick (index) {
      this.tabActiveIndex = index
    },

    tabClasses (index) {
      return `tab ${index == this.tabActiveIndex ? 'active' : ''}`
    },

    getWidth () {
      let translateX = 640
      const width = document.body.getBoundingClientRect().width
      if (width > 1280 && width <= 1680) {
        translateX = 960
      } else if (width >= 1920) {
        translateX = 1280
      }
      return translateX
    },

    loadImage (node, i) {
      const width = this.getWidth()
      const imgHeight = [...this.imgHeight]
      imgHeight[i] = width / node.path[0].naturalWidth * node.path[0].naturalHeight
      this.imgHeight = imgHeight
    },

    getImgStyle (i) {
      if (this.imgHeight[i]) {
        return {
          height: this.imgHeight[i] + 'px'
        }
      }
    }
  },

  computed: {
    getWrapStyle () {
      const translateX = this.getWidth()
      return {
        width: translateX * this.currentTabs.length + 'px',
        transform: `translateX(${this.tabActiveIndex * -translateX}px)`
      }
    },
  },

  watch: {
    tabs (newValue) {
      this.currentTabs = newValue.filter(item => (item.desc === 'aecHome'))
    }
  }

}
</script>

<style lang="less" scoped>

.tabs.animate {
  .tab {
    margin: 0 60px;

    @media (min-width: 1280px) and (max-width: 1680px){
      margin: 0 90px;
    }
          
    @media screen and (min-width: 1920px){
      margin: 0 120px;
    }
  }
}

.item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tabs {
  display: flex;

  .tab {
    padding: 10px 60px;
    margin: 0 120px;
    cursor: pointer;
    border-bottom: 1px dashed #d3d3d3;
    transition: all .5s ease-in-out;

    @media (min-width: 1280px) and (max-width: 1680px){
      padding: 15px 90px;
      margin: 0 180px;
      border-width: 1.5px;
    }
          
    @media screen and (min-width: 1920px){
      padding: 20px 120px;
      margin: 0 240px;
      border-width: 2px;
    }
  }

  .tab.active {
    border-color: #f45937;
  }
}

.tabs-content {
  display: flex;
  padding: 40px 0px 0px 0px;
  width: 640px;
  overflow: hidden;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 960px;
  }
        
  @media screen and (min-width: 1920px){
    width: 1280px;
  }

  .imgs {
    display: flex;
    transition: all .5s ease-in-out;
  }

  img {
    width: 640px;
    @media (min-width: 1280px) and (max-width: 1680px){
      width: 960px;
    }
          
    @media screen and (min-width: 1920px){
      width: 1280px;
    }
  }
}
</style>